import { api } from '../../store/api'

export default {
  methods: {
    async fetchBusinesscustomerBusinessgroups () {
      return (await api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + "/businesscustomer/businessgroups/get", { bid: this.$store.state.auth.bid })).data.data
		},
		addGroup(payload){
			let businessgroups = [];
			for(let group of payload){
				businessgroups.push(this.$store.state.businessgroups.businessgroups.find(g => g.Groupname === group))
			}
			return businessgroups;
		}
  }
}
